import { AutocompleteSource } from "@algolia/autocomplete-core";
import { getAlgoliaResults } from "@algolia/autocomplete-js";
import { ProductMapper } from "@omni/mappers/product/product.mapper";
import { AlgoliaSearchAutocompleteProduct } from "@omni/types/api/search/algolia/product/autocompleteProduct.model";
import { BffSearchProduct } from "@omni/types/api/search/bff/product/product.model";
import { isDefined } from "@omni/utils/helper.utils";
import { isEmpty } from "lodash-es";

import {
    PRODUCT_COUNT,
    PRODUCTS_SOURCE_ID
} from "@/components/Search/SearchBar/config/searchBar.config";
import transformQueryForMultiSku from "@/components/Search/SearchBar/helpers/multiSku.helpers";
import { ProductsSourceType } from "@/components/Search/SearchBar/types/searchBar.types";
import { AlgoliaClient } from "@/services/algolia/types/client.types";
import { AlgoliaSearchResult } from "@/services/algolia/types/search.types";

export const productsSource = (
    indexName: string,
    searchClient?: AlgoliaClient,
    initialProducts?: Array<BffSearchProduct>
): AutocompleteSource<ProductsSourceType> => ({
    sourceId: PRODUCTS_SOURCE_ID,
    getItems({ setContext, state, query }) {
        if (!query && isDefined(initialProducts) && !isEmpty(initialProducts)) {
            const context = state.context;
            context.nbProductHits = initialProducts.length;
            setContext(context);

            return initialProducts.map(
                ProductMapper.fromBffSearchToAlgoliaSearch
            );
        }

        return isDefined(searchClient)
            ? getAlgoliaResults<AlgoliaSearchAutocompleteProduct>({
                  searchClient: searchClient,
                  queries: [
                      {
                          indexName: indexName,
                          params: {
                              query: query,
                              hitsPerPage: PRODUCT_COUNT,
                              clickAnalytics: true
                          }
                      }
                  ].map(transformQueryForMultiSku),
                  transformResponse({ results }) {
                      const productsResult =
                          results[0] as AlgoliaSearchResult<ProductsSourceType>;

                      const context = state.context;
                      context.nbProductHits = productsResult.nbHits;
                      setContext(context);

                      return productsResult.hits;
                  }
              })
            : [];
    }
});
